import { render, staticRenderFns } from "./CorrelationArrows.vue?vue&type=template&id=5e615ec2"
import script from "./CorrelationArrows.vue?vue&type=script&lang=ts"
export * from "./CorrelationArrows.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e615ec2')) {
      api.createRecord('5e615ec2', component.options)
    } else {
      api.reload('5e615ec2', component.options)
    }
    module.hot.accept("./CorrelationArrows.vue?vue&type=template&id=5e615ec2", function () {
      api.rerender('5e615ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/CorrelationArrows.vue"
export default component.exports